import { roleRoutes } from "utils/roles";
import { useAuthToken } from "../../providers/authProviders";
import { Navigate } from "react-router-dom";

/**
 * Permite el paso solo a usuarios con role.holdingAdmin (multicurrier).
 * Si no, redirige a "/".
 */
const allowedRoles = [roleRoutes.holdingAdmin];

export default function RequireHolding({ children }) {
  const { isAuthenticated, role } = useAuthToken();

  if (!isAuthenticated || !allowedRoles.includes(role)) {
    return <Navigate to="/" />;
  }

  return children;
}
